<div ref="qList" class="tt-c-questions">
  <tt-user-toolbar v-if="qaConfig.displayUserToolbar"></tt-user-toolbar>
  <div v-if="total > 0" class="tt-c-questions__toolbar tt-c-toolbar">
    <div class="tt-c-toolbar__content-left">
      <span ref="total" class="tt-c-questions__total" tabindex="-1" v-html="$msg('qa.questionCount', [total], total)"></span>
      <tt-menu v-if="showSort" ref="sortByMenu">
        <tt-button ref="menuTrigger" slot="menuTrigger" type="toolbar" class="tt-c-questions__sort" :aria-label="$msg('qa.sortQuestions')">
          <span class="tt-c-questions__sort-text" v-html="sortByTitle"></span>
          <tt-icon size="xxs" name="arrow-fill"></tt-icon>
        </tt-button>
        <tt-menu-list ref="sortByMenuList" :menuItems="sortOptions" @menuItemSelected="sortOrderSelected" type="dropdown"></tt-menu-list>
      </tt-menu>
    </div>
  </div>

  <div class="tt-c-questions__list">
    <tt-comments-question @commentsLoaded="commentsLoaded" v-if="qaConfig.showCheckoutChatterOnQAWidget"></tt-comments-question>
    <tt-question v-for="question in questions"
                 :isRelated="question.catItem.sku !== currentSku"
                 :question="question"
                 :key="question.id"
                 :submissionCtx="submissionCtx"
                 :showBestAnswer="!qaConfig.hideBestAnswer"
                 @showError="onShowError"></tt-question>
  </div>
  <tt-pagination :currentPage="currentPage" @updatePage="pageChange" :total="directQuestionTotal" :initialPageSize="qaConfig.initialPageSize" :pageSize="qaConfig.pageSize"></tt-pagination>

  <tt-related-questions-list v-if="showRelatedList" :submissionCtx="submissionCtx"></tt-related-questions-list>

</div>



// WEBPACK FOOTER //
// ./src/widgets/qa/qa.html